<template>
  <div :class="{ 'is-flex': getModuleConfig('card_layout') === 'flex' }"
    class="d-flex flex-column min-vh-100 content__background"
    :style="getModuleConfig('layout.display_bg_image') && { 'background-image': `url(${getModuleConfig('layout.bg_image')})` }">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />

    <div class="top" :style="topStyle">
      <div :class="`layout layout-${getModuleConfig(
        'member_card_section.background_layout'
      )}`" :style="{ backgroundColor: gradientColors[3] }">

        <svg width="0" height="0" style="display: block;">
          <defs>
            <clipPath id="wave" clipPathUnits="objectBoundingBox">
              <path
                d="M1,0V1c-0.0467-0.0352-0.1107-0.0848-0.2133-0.1004c-0.1026-0.0148-0.2267,0.0464-0.3481,0.0684C0.3067,0.9916,0.1333,1.008,0,0.892V0H1Z" />
            </clipPath>
          </defs>
        </svg>

        <svg width="0" height="0" style="display: block;">
          <defs>
            <clipPath id="wave-barcode" clipPathUnits="objectBoundingBox">
              <path
                d="M1 0v1C.953.974.89.938.786.927.684.916.56.96.438.977.307.994.133 1.006 0 .92V0z" />
            </clipPath>
          </defs>
        </svg>

        <svg width="0" height="0" style="display: block;">
          <defs>
            <clipPath id="wave-qrcode" clipPathUnits="objectBoundingBox">
              <path
                d="M1 0v1C.953.983.89.959.787.951.684.944.56.974.438.985.307.995.133 1.004 0 .948V0z" />
            </clipPath>
          </defs>
        </svg>

        <div v-for="i in 3" :key="i" :style="{ backgroundColor: gradientColors[3 - i] }" :class="`curve-${4 - i}`">
        </div>



        <Header :meta="meta" :page-title="getModuleConfig('page_title')" :page-image="getModuleConfig('page_image')"
          :page-kv-image="getModuleConfig('page_kv_image')" :header-section="getModuleConfig('header_section')" />
        <div class="py-3 px-2">
          <div v-if="getModuleConfig('member_card_section.enable') == true" class="card" :class="`layout-${getModuleConfig(
            'member_card_section.card_layout'
          )}`" :style="cardBackground">
            <div class="card__logo">
              <img v-if="getModuleConfig('member_card_section.display_logo')" :src="memberCardLevelLogo" :style="{
                width: getModuleConfig(
                  'member_card_section.logo_style.width'
                ),
                transform: `translate(${getModuleConfig(
                  'member_card_section.logo_style.translateX'
                ) || '0'
                  },${getModuleConfig(
                    'member_card_section.logo_style.translateY'
                  ) || '0'
                  })`,
              }" />
            </div>

            <div class="card__name" v-if="getModuleConfig('member_card_section.display_name') == true">
              {{ displayMemberName }}
            </div>
            <div class="card__avatar">
              <img v-if="
                getModuleConfig(
                  'member_card_section.display_customer_avatar'
                ) == true
              " :src="modifiedUser.avatar_url" class="rounded-circle" />
            </div>

            <div class="card__level" :style="{
              color: `${getModuleConfig(
                'member_card_section.customer_level_name_color'
              )}`,
              'border-color': `${getModuleConfig(
                'member_card_section.customer_level_name_color'
              )}`,
              visibility: `${getModuleConfig(
                'member_card_section.display_customer_level_name'
              ) && modifiedUser.loyalty.level_name
                ? 'visible'
                : 'hidden'
                }`,
            }">
              <template v-if="
                getModuleConfig(
                  'member_card_section.display_customer_level_name'
                ) == true && modifiedUser.loyalty.level_name
              ">
                {{ modifiedUser.loyalty.level_name }}
              </template>
            </div>

            <div class="card__point">
              <div v-if="
                getModuleConfig('member_card_section.display_points') == true
              " class="card__point__title" :style="{
                color: `${getModuleConfig(
                  'member_card_section.customer_points_name_color'
                )}`,
              }">
                {{ displayPointsName }}
              </div>
              <div v-if="
                getModuleConfig('member_card_section.display_points') == true
              " class="card__point__number" :style="{
                color: `${getModuleConfig(
                  'member_card_section.customer_points_color'
                )}`,
              }">
                {{ userPoints }}
              </div>
            </div>

            <div class="card__minibarcode" :style="{
              visibility: `${getModuleConfig('member_card_section.display_mini_barcode') ==
                true
                ? 'visible'
                : 'hidden'
                }`,
            }">
              <template v-if="
                (getModuleConfig('member_card_section.display_mini_barcode') ==
                  true)
              ">
                <button @click="$refs.minibarcode.open()">
                  <img src="./images/mini-barcode.svg" />
                </button>

                <div class="barcode-modal">
                  <popup ref="minibarcode" :noActions="true" :scrolling="true">
                    <div class="card p-4">
                      <div class="card__minibarcode__title">{{ getModuleConfig('member_card_section.barcode_title') }}</div>
                      <p v-if="showBarcodeError" class="s-text-danger">
                      </p>
                      <img v-else id="card__barcode-img" :src="barcode" />
                    </div>
                  </popup>
                </div>
              </template>
            </div>
          </div>

          <div class="card__barcode mt-3" v-if="
            (getModuleConfig('member_card_section.display_barcode') == true)
          ">
            <div class="card__barcode__title">{{ getModuleConfig('member_card_section.barcode_title') }}</div>
            <!-- <img class="" src="./images/barcode.png" /> -->
            <p v-if="showBarcodeError" class="s-text-danger">
            </p>
            <img v-else id="card__barcode-img" :src="barcode" />
          </div>

          <div class="card__qrcode mt-3" v-if="
            (getModuleConfig('member_card_section.display_qrcode') == true)
          ">
            <p v-if="showQrcodeError" class="s-text-danger">
              無法生成 QR code
            </p>
            <div v-else class="card__qrcode__container">
              <div class="card__qrcode__title">{{ getModuleConfig('member_card_section.qrcode_title') }}</div>
              <button @click="$refs.qrcode.open()">
                <img :src="qrcode" alt="QR Code" />
              </button>
            </div>

            <div class="barcode-modal">
                <popup ref="qrcode" :noActions="true" :scrolling="true">
                  <div class="card p-4">
                    <p v-if="showQrcodeError" class="s-text-danger">
                    </p>
                    <img v-else :src="qrcode" class="img-fluid" />
                  </div>
                </popup>
              </div>
          </div>


        </div>
      </div>
    </div>

    <div class="flex-fill body pt-2" :style="bodyStyle">
      <div v-if="isSectionLoading" class="text-center my-2">
        <b-spinner class="pl-6" variant="secondary"></b-spinner>
      </div>

      <template v-else>
        <div v-for="(section, index) in sections" :key="'section' + index" class="mb-3">
          <!-- menu_icon_section start -->
          <div v-if="section.key === 'menu_icon_section'" class="px-2">
            <div class="function">
              <div v-for="(i, idx) in section.menu_items.filter(
                (x) => !x.is_hidden
              )" class="function__item" :style="{ 'flex-basis': `${100 / section.column_number}%` }" :key="idx">
                <template v-if="i.is_external">
                  <a :target="i.target ? i.target : '_blank'" :href="i.url">
                    <div v-if="
                      i.icon_url == undefined ||
                      i.icon_url.split('.').pop() == 'svg'
                    " class="function__icon__wrapper">
                      <img class="function__icon" :style="{
                        maskImage: getIconMask(i),
                        webkitMaskImage: getIconMask(i),
                      }" />
                    </div>
                    <img v-else class="function__icon" :src="i.icon_url" />

                    <div class="function__title">{{ i.title }}</div>
                  </a>
                </template>
                <template v-else>
                  <router-link :to="parseIntentAndRoute(i)">
                    <div v-if="
                      i.icon_url == undefined ||
                      i.icon_url.split('.').pop() == 'svg'
                    " class="function__icon__wrapper">
                      <img class="function__icon" :style="{
                        maskImage: getIconMask(i),
                        webkitMaskImage: getIconMask(i),
                      }" />
                    </div>
                    <img v-else class="function__icon" :src="i.icon_url" />

                    <div class="function__title">{{ i.title }}</div>
                  </router-link>
                </template>
              </div>
            </div>
          </div>
          <!-- menu_icon_section end -->

          <!-- menu_list_section start -->
          <div v-if="section.key === 'menu_list_section'">
            <div class="menu">
              <span v-for="(i, idx) in section.menu_items" :key="idx">
                <router-link v-if="!i.is_external" class="menu__item" :to="parseIntentAndRoute(i)">
                  <span class="menu__title">{{ i.title }}</span>
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.2773 9.85059C13.2773 9.65723 13.1982 9.48144 13.0576 9.34961L6.44824 3.00391C6.32519 2.88086 6.17578 2.81055 5.99121 2.81055C5.62207 2.81055 5.34082 3.0918 5.34082 3.45215C5.34082 3.62793 5.41113 3.79492 5.52539 3.91797L11.6953 9.8418L5.52539 15.7744C5.41113 15.8975 5.34082 16.0557 5.34082 16.2314C5.34082 16.6006 5.62207 16.8818 5.99121 16.8818C6.17578 16.8818 6.3252 16.8027 6.44824 16.6885L13.0576 10.334C13.1982 10.1934 13.2773 10.0352 13.2773 9.85059Z"
                      fill="#C4C4C4" />
                  </svg>
                </router-link>
                <a v-else class="menu__item" :href="i.url" :target="i.target ? i.target : '_blank'">
                  <span class="menu__title">{{ i.title }}</span>
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.2773 9.85059C13.2773 9.65723 13.1982 9.48144 13.0576 9.34961L6.44824 3.00391C6.32519 2.88086 6.17578 2.81055 5.99121 2.81055C5.62207 2.81055 5.34082 3.0918 5.34082 3.45215C5.34082 3.62793 5.41113 3.79492 5.52539 3.91797L11.6953 9.8418L5.52539 15.7744C5.41113 15.8975 5.34082 16.0557 5.34082 16.2314C5.34082 16.6006 5.62207 16.8818 5.99121 16.8818C6.17578 16.8818 6.3252 16.8027 6.44824 16.6885L13.0576 10.334C13.1982 10.1934 13.2773 10.0352 13.2773 9.85059Z"
                      fill="#C4C4C4" />
                  </svg>
                </a>
              </span>
            </div>
          </div>
          <!-- menu_list_section end -->

          <!-- 會員資料 member_detail_section start -->
          <div v-if="section.key === 'member_detail_section'" class="px-2">
            <div v-for="(group, idx) in detail_fields" class="detail" :key="idx">
              <div class="detail__wrapper">
                <div v-for="(field, index2) in group" :key="'field' + index2" class="detail__item"
                  :class="field.col_span">
                  <div class="detail__title">{{ field.title }}</div>
                  <div class="detail__value">
                    {{ getFieldDisplayValue(field) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 會員資料 member_detail_section end -->

          <!-- 點數 member_point_section start -->
          <div v-if="section.key === 'member_point_section'">
            <div class="points-list">
              <div
                class="points-list__item"
                v-for="(point,idx) in expiringPoints"
                :key="idx"
              >
                <div class="points-list__title">{{ point.expired_at?`${moment(point.expired_at)?.format('YYYY/MM/DD')} 到期`:'永久有效' }}</div>
                <div class="points-list__point">{{ point.point?.toLocaleString('en-US') }}<span>{{ displayPointsName }}</span></div>
              </div>
            </div>
          </div>
          <!-- 點數 member_point_section end -->

          <!-- highlight_section start-->
          <div v-if="section.key === 'highlight_section'" class="px-2">
            <div v-for="(group, idx) in highlight_fields" :key="idx" class="highlight row">
              <div v-for="(field, fdx) in group" :key="fdx" class="d-flex flex-column" :class="field.col_span == 'full' ? 'col-12' : 'col'">
                <div class="highlight__title">
                  {{ field.title }}
                </div>
                <div class="highlight__value">{{ getFieldDisplayValue(field) }}</div>
              </div>
            </div>
          </div>
          <!-- highlight_section end-->
          <!-- level_progress_section start-->
          <div v-if="section.key === 'level_progress_section'" class="px-2">
            <div class="level_progress">

              <div class="level_progress__level">{{ modifiedUser.extra.loyalty_current_level_name }}</div>

              <div class="d-flex justify-content-between">

                <div>
                  <div class="level_progress__period mb-2" v-if="modifiedUser.extra.loyalty_current_level_start_at || modifiedUser.extra.loyalty_current_level_end_at">
                    <span>{{moment(modifiedUser.extra.loyalty_current_level_start_at).format('YYYY-MM-DD')}} ~ {{moment(modifiedUser.extra.loyalty_current_level_end_at).format('YYYY-MM-DD') }}</span>
                  </div>

                  <div>
                    <span class="mr-2">累積消費</span>
                    <span class="level_progress__amount">${{ formatCurrency(modifiedUser.extra.loyalty_current_level_amount) }}</span>
                  </div>
                </div>

                
                  <div class="d-flex flex-column align-items-end justify-content-end">
                    <div v-if="modifiedUser.extra.loyalty_renewal_level_remaining_amount">
                      <span class="level_progress__amount mr-2">${{
                        formatCurrency(modifiedUser.extra.loyalty_renewal_level_remaining_amount)
                      }}</span>續等{{ modifiedUser.extra.loyalty_renewal_level_name }}
                    </div>
                    <div v-if="modifiedUser.extra.loyalty_upgrade_level_remaining_amount">
                      <span class="level_progress__amount mr-2">${{
                        formatCurrency(modifiedUser.extra.loyalty_upgrade_level_remaining_amount)
                      }}</span>升等{{ modifiedUser.extra.loyalty_upgrade_level_name }}
                    </div>
                  </div>
                
              </div>

              <div class="level_progress__remark" v-if="upgradeRemarkIsEnabled">
                {{ modifiedUser.extra.loyalty_upgrade_level_remark }}

              </div>

              <div class="level_progress__progress progress my-2" v-if="upgradeProgressBarIsEnabled">

                <div class="progress-bar" role="progressbar"
                  :style="{ width: `${currentAmount / upgradeAmount * 100}%` }"></div>

                <div v-if="modifiedUser.extra.loyalty_renewal_level_remaining_amount" class="level_progress__progress__icon"
                  :style="{
                    left: `${renewalAmount / upgradeAmount * 100}%`,
                    backgroundColor: currentAmount < renewalAmount ? '#e6e6e6' : 'var(--s-primary)',
                    transform: renewalAmount / upgradeAmount==0? 'translate3D(0, -50%, 0)' : 'translate3D(-10px, -50%, 0)'
                  }">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white">
                    <path v-if="currentAmount < renewalAmount" d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z" />
                    <path v-else
                      d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z" />
                  </svg>
                </div>

                <div v-if="modifiedUser.extra.loyalty_upgrade_level_remaining_amount" class="level_progress__progress__icon"
                  :style="{ left: `100%`, backgroundColor: currentAmount < upgradeAmount ? '#e6e6e6' : 'var(--s-primary)', transform: 'translateX(-20px) translateY(-50%)' }">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white">
                    <path v-if="currentAmount < upgradeAmount" d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z" />
                    <path v-else
                      d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z" />
                  </svg>
                </div>
              </div>

              <div class="level_progress__text" v-if="upgradeProgressBarIsEnabled">
                <div class="level_progress__text__item" :style="{                  
                  width: `calc(${renewalAmount / upgradeAmount * 100}% - 10px)`,                   
                }"></div>
                <div v-if="modifiedUser.extra.loyalty_renewal_level_remaining_amount" class="level_progress__text__item" :style="{                  
                  color: currentAmount >= renewalAmount ? 'var(--s-primary)' : 'var(--s-gray)',                  
                }">
                  <div class="text-center">
                    <div>續等{{ modifiedUser.extra.loyalty_renewal_level_name }}</div>
                    <div>${{ formatCurrency(modifiedUser.extra.loyalty_renewal_level_amount) }}</div>
                  </div>
                </div>

                <div v-if="modifiedUser.extra.loyalty_upgrade_level_remaining_amount" class="level_progress__text__item" :style="{
                  width: `auto`,
                  color: currentAmount >= upgradeAmount ? 'var(--s-primary)' : 'var(--s-gray)',
                  flex: '1 1 auto',
                  alignItems: 'flex-end',
                }">
                  <div class="text-center ml-2">
                    <div>升等{{ modifiedUser.extra.loyalty_upgrade_level_name }}</div>
                    <div>${{ formatCurrency(modifiedUser.extra.loyalty_upgrade_level_amount) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- level_progress_section end-->
        </div>

        <div v-if="getModuleConfig('intro_section.enable')" class="mb-3 px-2">
          <div class="info">
            <div class="px-3 py-2">
              <h3 class="info__title">
                {{ getModuleConfig("intro_section.form_title") }}
              </h3>
              <div class="info__desc">
                {{ getModuleConfig("intro_section.form_desc") }}
              </div>
            </div>
            <div class="info__content" v-html="getModuleConfig('intro_section.content')"></div>
          </div>
        </div>

        <div v-if="
          getModuleConfig('unbind_button') &&
          getModuleConfig('unbind_button').enable
        " class="p-2 text-center text-small">
          <router-link :to="{ name: 'LiffMemberCenterUnbind' }" class="unbind__button">
            <u>{{ getModuleConfig("unbind_button").button_text }}</u>
          </router-link>
        </div>

        <div v-if="
          getModuleConfig('footer_section') &&
          getModuleConfig('footer_section').enable
        " class="p-2 text-center text-small footer__content">
          <div v-html="getModuleConfig('footer_section').content"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Page/Liff/Shared/HeaderV3";
import { mapGetters, mapActions } from "vuex";
import bwipjs from "bwip-js";
import _ from "lodash";
import pointApi from "@/apis/liff/v2/point";
import moduleMap from "@/mixins/liff/memberCenter/moduleMap";
import authApi from "@/apis/liff/v2/auth";
import merchantApi from "@/apis/liff/v2/merchant";
import Popup from "@/components/Page/Liff/Shared/Popup.vue";
import Loading from "@/components/Page/Liff/Shared/Loading";
import { applyThousandsSeperator } from "@/utils/numberUtils";
import moment from "moment";

const requireImage = (path) =>
  require(`@/assets/images/liff/module-icon/${path}`);

export default {
  mixins: [moduleMap],
  components: {
    Header,
    Popup,
    Loading,
  },
  props: {
    isFlexLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sections: [],
      detail_fields: [],
      highlight_fields: [],
      showBarcodeError: false,
      barcode: null,
      page: 1,
      userPoints: "-",
      merchants: [],
      isLoading: true,
      isSectionLoading: true,
      loyaltyLevel: {
        level_name: "",
        logo_url: "",
        card_picture_url: "",
      },
      availablePoints: {
        point: 0,
        expired_at: null,
        expiring: []
      },
      expiringPoints: [],
      qrcode: null,
      showQrcodeError: false,
    };
  },
  computed: {
    ...mapGetters("liffAuth", ["user"]),
    ...mapGetters({
      meta: "liffGeneral/meta",
    }),
    memberCardLevelLogo() {
      return (this.getModuleConfig('member_card_section.use_level_logo') &&
        this.modifiedUser.loyalty.logo_url) ||
        this.getModuleConfig('member_card_section.logo')
    },
    displayPointsName() {
      return (
        this.getModuleConfig("member_card_section.points_name") || "點數"
      );
    },
    displayMemberName() {
      const memberNameCol = this.getModuleConfig("member_card_section.display_name_column") ?? "name"
      return _.get(this.modifiedUser, memberNameCol, '')
    },
    modifiedUser() {
      return {
        ...this.user,
        loyalty: this.loyaltyLevel,
        available_points: this.availablePoints,
      }
    },
    barcodeField() {
      const memberBarcodeCol = (this.getModuleConfig("member_card_section.barcode") ?? "customer_number")
        ? (this.getModuleConfig("member_card_section.barcode") ?? "customer_number")
        : "customer_number"
      let merchantType =
        memberBarcodeCol.split(":").length == 2
          ? memberBarcodeCol.split(":")[0].toUpperCase()
          : false;
      let isExtra = memberBarcodeCol.includes("extra.");
      let isLoyalty = memberBarcodeCol.includes("loyalty.");
      let isAvailablePoint = memberBarcodeCol.includes("available_points.");
      let field_name =
        memberBarcodeCol.split(".").length == 2
          ? memberBarcodeCol.split(".")[1]
          : memberBarcodeCol.split(":").length == 2
            ? memberBarcodeCol.split(":")[1]
            : memberBarcodeCol;
      return this.getFieldDisplayValue({
        is_extra: isExtra,
        is_loyalty: isLoyalty,
        is_available_point: isAvailablePoint,
        merchant_type: merchantType,
        field_name: field_name,
        matched_key: memberBarcodeCol
      })
    },
    address() {
      if (!this.modifiedUser || !this.modifiedUser.extra) {
        return null;
      }
      return (
        (this.modifiedUser.extra.city || "") +
        (this.modifiedUser.extra.district || "") +
        (this.modifiedUser.extra.address || "")
      );
    },
    // groupedDetailFields() {
    //   return this.detail_fields.map((x) => {
    //     return Array.isArray(x) ? x : [x];
    //   });
    // },
    topStyle() {
      let otherStyle = {};
      if (this.getModuleConfig("member_card_section")) {
        otherStyle = this.checkColorValue(
          this.getModuleConfig("member_card_section.layout_bg_top_color") || "#FFFFFF00",
          "--liff-card_bg_top_color",
          otherStyle
        );
        otherStyle = this.checkColorValue(
          this.getModuleConfig("member_card_section.layout_bg_bottom_color") || "#FFFFFF00",
          "--liff-card_bg_bottom_color",
          otherStyle
        );
        otherStyle = this.checkColorValue(
          this.getModuleConfig("member_card_section.customer_name_color"),
          "--liff-card_name_text_color",
          otherStyle
        );
      }
      return otherStyle;
    },

    bodyStyle() {
      let otherStyle = {};
      if (this.getModuleConfig("content")) {
        otherStyle = this.checkColorValue(
          this.getModuleConfig("content.bg_color"),
          "--liff-body_bg_top_color",
          otherStyle
        );
        otherStyle = this.checkColorValue(
          this.getModuleConfig("content.bg_bottom_color") || this.getModuleConfig("content.bg_color"),
          "--liff-body_bg_bottom_color",
          otherStyle
        );
        otherStyle = this.checkColorValue(
          this.getModuleConfig("content.border_color"),
          "--liff-body_border_color",
          otherStyle
        );
      }
      return otherStyle;
    },

    cardBackground() {
      let background = [];
      let shadow = 'transparent';
      let border = 'none';

      if (this.getModuleConfig("member_card_section.display_card_luster")) {
        background.push(
          `linear-gradient(135deg,${this.getModuleConfig(
            "member_card_section.card_luster_left_left"
          )} 0%,${this.getModuleConfig(
            "member_card_section.card_luster_left_right"
          )} 50%,${this.getModuleConfig(
            "member_card_section.card_luster_right_left"
          )} 50%,${this.getModuleConfig(
            "member_card_section.card_luster_right_right"
          )} 100%)`
        );


        if (this.getModuleConfig("member_card_section.shadow")) {
          shadow = `2px 2px 14px ${this.getModuleConfig("member_card_section.shadow")}`;
        }
      }
      else {
        shadow = 'none';
      }
      // else {
      //   style.push(
      //     `linear-gradient(135deg,rgba(255, 255, 255, 0) 0%,rgba(0, 0, 0, .05) 50%,rgba(255, 255, 255, .2) 50%,rgba(255, 255, 255, 0) 100%)`
      //   );
      // }

      if(this.getModuleConfig("member_card_section.broder_color")){
        border = `1px solid ${this.getModuleConfig("member_card_section.broder_color")}`;
      }

      if (this.getModuleConfig("member_card_section.display_card_picture")) {
        if (
          this.getModuleConfig("member_card_section.use_level_card_picture") &&
          this.modifiedUser.loyalty.card_picture_url
        ) {
          background.push(`url('${this.modifiedUser.loyalty.card_picture_url}')`);
        } else if (
          this.getModuleConfig("member_card_section.card_picture_url")
        ) {
          background.push(
            `url('${this.getModuleConfig(
              "member_card_section.card_picture_url"
            )}')`
          );
        }
      }

      return { background: background.join(","), boxShadow: shadow, border: border };
    },
    topLayoutImage() {
      const color = encodeURIComponent(
        this.getModuleConfig("content.bg_color")
      );

      switch (this.getModuleConfig("member_card_section.background_layout")) {
        case "B":
          return {
            backgroundImage: `url('data:image/svg+xml,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 42" style="enable-background:new 0 0 375 42;" xml:space="preserve"><style type="text/css">.st0{fill:${color}; -webkit-filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3)); filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3));}</style><g><path class="st0" d="M0,42h187.5C72,42,0,10,0,10V42z"/><path class="st0" d="M187.5,42H375V10C375,10,303,42,187.5,42z"/></g></svg>')`,
          };
        case "C":
          return {
            backgroundImage: `url('data:image/svg+xml,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 100" style="enable-background:new 0 0 375 100;" xml:space="preserve"><style type="text/css">.st0{fill:${color}; -webkit-filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3)); filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3));}</style><path class="st0" d="M325,60H0v40h375V60V10C375,37.6,352.6,60,325,60z"/></svg>')`,
          };
        case "D":
          return {
            backgroundImage: `url('data:image/svg+xml,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 45" style="enable-background:new 0 0 375 45;" xml:space="preserve"><style type="text/css">.st0{fill:${color}; -webkit-filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3)); filter: drop-shadow( 0px -5px 5px rgba(0, 0, 0, .3));}</style><path class="st0" d="M295,12.2c38.5,4.3,62.5,18.2,80,28.1V45H0V10c50,32.5,115,28,164.5,21.4C210,25.2,256.5,8,295,12.2z"/></svg>')`,
          };
        case "A":
        default:
          return {};
      }
    },
    upgradeProgressBarIsEnabled() {
      return this.getModuleConfig("level_progress_section.progress_bar.enable") ?? false;
    },
    upgradeRemarkIsEnabled() {
      return this.getModuleConfig("level_progress_section.upgrade_remark.enable") ?? false;
    },
    currentAmount() {
      return parseInt(this.modifiedUser.extra?.loyalty_current_level_amount ?? 0);
    },
    renewalAmount() {      
      return parseInt(this.modifiedUser.extra?.loyalty_renewal_level_amount ?? 0);
    },
    upgradeAmount() {      
      return parseInt(this.modifiedUser.extra?.loyalty_upgrade_level_amount ?? 0);
    },
    gradientColors() {
      return this.getGradientColors(this.topStyle['--liff-card_bg_top_color'], this.topStyle['--liff-card_bg_bottom_color'])
    },
    moment() {
      return moment;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      fetchMe: 'liffAuth/fetchMe',
    }),
    formatCurrency(value) {
      return Number(value || 0).toLocaleString('zh-TW', { maximumFractionDigits: 0 });
    },
    async syncLineDataIfNeeded() {
      try {
        if (this.getModuleConfig('data_source.force_update_from_line') !== true) {
          return;
        }

        const updatedDate = new Date(this.user.updated_at).toISOString().split('T')[0];
        const today = new Date().toISOString().split('T')[0];

        if (updatedDate === today) {
          return;
        }

        await authApi.syncLineData();

        this.fetchMe();
      } catch (error) {
        console.log('syncLineData error:', error);
      }
    },
    checkColorValue(config, styleName, styleObject) {
      if (config !== undefined && config !== "#" && config !== "") {
        return Object.assign({ [styleName]: config }, styleObject);
      }
      return styleObject;
    },
    getFieldDisplayValue(field) {
      let customer = this.modifiedUser;
      let customerMerchant = false;
      if (field.type === "address") {
        return this.address();
      }
      if (field.merchant_type) {
        customerMerchant = this.merchants.find(
          (merchant) => merchant.type === field.merchant_type
        );
        if (customerMerchant) {
          customer = this.modifiedUser.users?.find(
            (item) => item.type === field.merchant_type
          );
        } else {
          customer = false;
        }
      }
      if (customer) {
        let value
        if (field.is_extra) {
          value = customer.extra[field.field_name] ?? "";
        } else if (field.is_loyalty) {
          value = customer.loyalty[field.field_name] ?? "";
        } else if (field.is_available_point) {

        // 處理巢狀屬性路徑，支援陣列索引
        if (field.field_name) {
            const pathParts = field.field_name.split('.');
            let result = customer.available_points;

            for (const part of pathParts) {
              if (result === null || result === undefined) {
                result = "";
                break;
              }

              // 檢查是否為陣列索引格式 [0], [1] 等
              if (part.includes('[') && part.includes(']')) {
                const arrayName = part.split('[')[0];
                const index = parseInt(part.split('[')[1].split(']')[0]);

                if (Array.isArray(result[arrayName]) && !isNaN(index)) {
                  result = result[arrayName][index];
                } else {
                  result = "";
                  break;
                }
              } else {
                result = result[part];
              }
            }

            value = result ?? "";
          } else {
            value = "";
          }
        } else {
          value = customer[field.field_name] ?? "";
        }

        // formatting
        if (field.type === 'ntd') {
          value = applyThousandsSeperator(Number(value))
        }

        return value
      }
      // 如果org裡面有merchant，但是沒有資料，則顯示空白
      if (customerMerchant) {
        return "";
      }
      // 如果merchant是錯的，則顯示不支援
      return "不支援";
    },
    async init() {
      // Sync LINE data if needed (runs independently in background)
      this.syncLineDataIfNeeded();

      // 檢查是否有啟用強制綁定及綁定狀態
      let { isEnabledForceBind, execBindResult } =
        await authApi.checkForceBind();

      if (
        isEnabledForceBind &&
        execBindResult === "external_customer_not_found"
      ) {
        this.$router.push({
          name: "LiffRegisterNotRegister",
        });
      }

      if (this.getModuleConfig("data_source.load_point") === true) {
        const data = await pointApi.getAvailablePoints();
        this.userPoints = data.point?.toLocaleString('en-US') ?? '-';
        this.availablePoints = data
        this.expiringPoints = await pointApi.getAllExpiringPoints();

        this.expiringPoints = this.expiringPoints.sort((a, b) => {
          // 1. If both are empty, they are equal
          if (a.expired_at === b.expired_at) return 0;
          
          // 2. If 'a' is empty, move it to the end (return positive)
          if (a.expired_at === '') return 1;
          
          // 3. If 'b' is empty, move 'a' to the front (return negative)
          if (b.expired_at === '') return -1;
          
          // 4. Otherwise, compare strings normally for ascending order
          return a.expired_at.localeCompare(b.expired_at);
        });
      }

      if (this.getModuleConfig("data_source.load_customer_level") === true) {
        const loyalty = await pointApi.getLoyaltyLevel();
        this.loyaltyLevel = loyalty.data
        if (loyalty?.data?.is_fetch_data) {
          await this.fetchMe()
        }
      }

      // 只有當啟用顯示 barcode 時，才 generate barcode

      if (
        this.getModuleConfig("member_card_section.display_barcode") === true ||
        this.getModuleConfig("member_card_section.display_mini_barcode") ===
        true
      ) {
        this.generateBarcode();
      }

      // 生成 QR code
      if (this.getModuleConfig("member_card_section.display_qrcode") === true) {
        this.generateQrcode();
      }

      this.isLoading = false;

      await this.getMerchants();

      // 排序 section
      let sectionKeys = [
        "menu_icon_section",
        "menu_list_section",
        "member_card_section",
        "member_point_section",
        "member_detail_section",
        "highlight_section",
        "level_progress_section",
      ];
      let sections = [];
      for (let i = 0; i < sectionKeys.length; i++) {
        let config = this.getModuleConfig(sectionKeys[i]);

        if (config) {
          config.key = sectionKeys[i];

          if (config.enable === true) {
            sections.push(config);
          }
        }
      }
      this.sections = _.sortBy(sections, "order");

      // 排序 menu_icon_section
      if (this.sections.some((x) => x.key == "menu_icon_section")) {
        let section = this.sections.find((x) => x.key == "menu_icon_section");
        section.menu_items = _.sortBy(section.menu_items, "order");
      }

      // 排序 menu_list_section
      if (this.sections.some((x) => x.key == "menu_list_section")) {
        let section = this.sections.find((x) => x.key == "menu_list_section");
        section.menu_items = _.sortBy(section.menu_items, "order");
      }

      // 排序 detail fields
      let memberDetailSection = this.getModuleConfig("member_detail_section");

      if (memberDetailSection.enable === true) {

        let groups = memberDetailSection.fields.filter((field) => {
          return Array.isArray(field);
        });

        groups = groups.map((fields) => {
          //let fields = Array.isArray(group[0]) ? group : [group];

          return _.sortBy(
            fields.map((field) => {
              let merchantType =
                field.matched_key?.split(":").length == 2
                  ? field.matched_key.split(":")[0].toUpperCase()
                  : false;
              let isExtra = field.matched_key?.includes("extra.");
              let isLoyalty = field.matched_key?.includes("loyalty.");
              let isAvailablePoint = field.matched_key?.includes("available_points.");
              let field_name =
                field.matched_key?.split(".").length == 2
                  ? field.matched_key?.split(".")[1]
                  : field.matched_key?.split(":").length == 2
                    ? field.matched_key?.split(":")[1]
                    : field.matched_key;
              return {
                ...field,
                is_extra: isExtra,
                is_loyalty: isLoyalty,
                is_available_point: isAvailablePoint,
                merchant_type: merchantType,
                field_name: field_name,
              };
            }),
            "order"
          );
        });

        this.detail_fields = groups;
      }


      // highlight 分組
      let highlightSection = this.getModuleConfig("highlight_section");

      if (this.getModuleConfig("highlight_section.enable") === true && this.getModuleConfig("highlight_section.fields")) {
        let groups = highlightSection.fields.filter((field) => {
          return Array.isArray(field);
        });

        groups = groups.map((fields) => {
          //let fields = Array.isArray(group[0]) ? group : [group];

          return _.sortBy(
            fields.map((field) => {
              let merchantType =
                field.matched_key?.split(":").length == 2
                  ? field.matched_key.split(":")[0].toUpperCase()
                  : false;
              let isExtra = field.matched_key?.includes("extra.");
              let isLoyalty = field.matched_key?.includes("loyalty.");
              let isAvailablePoint = field.matched_key?.includes("available_points.");
              let field_name =
                field.matched_key?.split(field.matched_key.includes('.') ?
                  '.' : field.matched_key.includes(':') ?
                    ':' : '').slice(1).join(field.matched_key.includes('.') ?
                      '.' : field.matched_key.includes(':') ?
                        ':' : field.matched_key);
              return {
                ...field,
                is_extra: isExtra,
                is_loyalty: isLoyalty,
                is_available_point: isAvailablePoint,
                merchant_type: merchantType,
                field_name: field_name,
              };
            }),
            "order"
          );
        });

        this.highlight_fields = groups;
      }

      this.isSectionLoading = false;
    },
    async getMerchants() {
      const data = await merchantApi.list();
      this.merchants = data.data;
    },
    parseIntentAndRoute(i) {
      if (i.url) {
        return i.url
      }

      if (i.type) {
        const orgCode = this.$route.params.orgCode || this.$route.params.org_code
        if (this.moduleMap.find((x) => x.type == i.type)) {
          return {
            name: this.moduleMap.find((x) => x.type == i.type).value,
            params: { org_code: orgCode },
          }
        }

        if (i.type.startsWith('liff_page')) {
          const path = i.type.substring(10)
          return `/${orgCode}/liff/page/${path}`
        }
      }

      return '/'
    },
    generateBarcode() {
      let canvasElement = document.createElement("canvas");

      try {
        bwipjs.toCanvas(canvasElement, {
          bcid: "code128", // Barcode type
          text: this.barcodeField,
          scale: 2, // 3x scaling factor
          height: 10, // Bar height, in millimeters
          includetext: this.getModuleConfig('member_card_section.barcode_text_hidden') === false, // Show human-readable text
          textxalign: "center", // Always good to set this
        });
        //document.getElementById("card__barcode-img").src =
        this.barcode = canvasElement.toDataURL("image/png");
        this.showBarcodeError = false;
      } catch (e) {
        console.log("barcode generate error", e);
        this.showBarcodeError = true;
      }
    },

    generateQrcode() {
      let canvasElement = document.createElement("canvas");

      try {
        // 取得 QR code 資料配置
        const qrcodeDataConfig = this.getModuleConfig("member_card_section.qrcode_data");

        if (!qrcodeDataConfig) {
          this.showQrcodeError = true;
          return;
        }

        // 替換變數的函數
        const replaceVariables = (text) => {
          // 替換 {$extra.xxx} 格式的變數
          return text.replace(/\{\$extra\.([^}]+)\}/g, (match, fieldName) => {
            return this.modifiedUser.extra?.[fieldName] || '';
          }).replace(/\{\$([^}]+)\}/g, (match, fieldName) => {
            // 替換其他 {$xxx} 格式的變數
            return this.modifiedUser[fieldName] || '';
          });
        };

        // 解析 JSON 字串並替換變數
        let qrContent;
        try {
          // 先替換變數，再解析 JSON
          const replacedData = replaceVariables(qrcodeDataConfig);
          const parsedData = JSON.parse(replacedData);
          qrContent = JSON.stringify(parsedData);
        } catch (parseError) {
          // 如果不是 JSON 格式，直接使用替換後的內容
          qrContent = replaceVariables(qrcodeDataConfig);
        }



        bwipjs.toCanvas(canvasElement, {
          bcid: "qrcode", // QR code type
          text: qrContent,
          scale: 3, // 3x scaling factor
          width: 400, // QR code width
          height: 400, // QR code height
          includetext: false, // Don't show text below QR code
        });

        this.qrcode = canvasElement.toDataURL("image/png");
        this.showQrcodeError = false;
      } catch (e) {
        console.log("qrcode generate error", e);
        this.showQrcodeError = true;
      }

    },

    handleEdit() {
      this.$router.push({ name: "LiffMemberCenterEdit" });
    },
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("member_center", key);
    },
    getIcon(path) {
      try {
        return requireImage(path);
      } catch {
        return "";
      }
    },
    getIconMask(i) {
      return `url(${i.icon_url == undefined ? this.getIcon(`${i.icon_type || i.type}.svg`) : i.icon_url
        })`;
    },
    getGradientColors(startColor, endColor) {
      return [
        startColor,
        this.interpolate(startColor, endColor, 0.33),
        this.interpolate(startColor, endColor, 0.66),
        endColor
      ];
    },
    interpolate(c1, c2, factor) {



      function hexToRgba(hex) {
        const value = hex.slice(1);
        const hasAlpha = value.length === 8;

        const r = parseInt(value.slice(0, 2), 16);
        const g = parseInt(value.slice(2, 4), 16);
        const b = parseInt(value.slice(4, 6), 16);
        const a = hasAlpha ? parseInt(value.slice(6, 8), 16) : 255;

        return { r, g, b, a };
      }

      function rgbaToHex({ r, g, b, a }) {
        return (
          "#" +
          [r, g, b, a]
            .map((v) => v.toString(16).padStart(2, "0"))
            .join("")
        );
      }

      const color1 = hexToRgba(c1);
      const color2 = hexToRgba(c2);

      const r = Math.round(color1.r + (color2.r - color1.r) * factor);
      const g = Math.round(color1.g + (color2.g - color1.g) * factor);
      const b = Math.round(color1.b + (color2.b - color1.b) * factor);
      const a = Math.round(color1.a + (color2.a - color1.a) * factor);

      return rgbaToHex({ r, g, b, a });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "style.scss";

.barcode-modal {
  ::v-deep .popup__header {
    margin-bottom: 0px;
  }

  ::v-deep .popup__panel {
    background-color: transparent;

    padding: 0;

    box-shadow: none;
  }

  ::v-deep .popup__body.scrolling {
    height: auto;
  }

  .card {
    background: white;
    min-height: 40vh;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.info {
  border-radius: 10px;
  border: solid 1px #e5e5ea;
  background: white;

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: var(--liff-primary_text_color);
  }

  &__desc {
    font-size: 16px;
    color: var(--liff-secondary_text_color);
  }

  &__content {
    border-top: solid 1px #e5e5ea;
    font-size: 14px;
    padding: 16px;
    color: var(--liff-secondary_text_color);
  }
}

.unbind__button {
  color: var(--liff-secondary_text_color);
  text-decoration: underline;
}

.footer__content {
  color: var(--liff-primary_text_color);
}

::v-deep .popup__backdrop {
  opacity: 0.6;
}
</style>
